module.exports = __webpack_public_path__ + "img/sw-ys42.09a760ce.jpg";